var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company)?_c('company-form',{attrs:{"newCompany":false},on:{"submit":_vm.updateCompany,"cancel":_vm.cancel},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }